<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Reporte de ventas por productos</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button type="button" @click="mostrarHistoricos" class="btn-secondary">
            <i class="fa fa-history"></i><span>Historial</span>
          </button>
          <button type="button" @click="exportarDocumento('E')" class="btn-success">
            <i class="fa fa-file-excel-o"></i><span>Excel</span>
          </button>
          <button type="button" @click="exportarDocumento('P')" class="btn-danger">
            <i class="fa fa-file-pdf-o"></i><span>PDF</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">          
          <div class="col-xs-12 col-md-8">
            <div class="form-inline">
              <label>
                <input
                  v-model="form.tipoFecha"
                  type="radio"
                  value="H"
                />
                <span>Hoy</span>
              </label>
              <label>
                <input
                  v-model="form.tipoFecha"
                  type="radio"
                  value="A"
                />
                <span>Ayer</span>
              </label>
              <label>
                <input
                  v-model="form.tipoFecha"
                  type="radio"
                  value="P"
                />
                <span>Personalizado</span>
              </label>
              <div class="form-field" v-show="form.tipoFecha == 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="desde"
                    v-model="form.fechaDesde"
                    locale="es"
                    only-date
                    no-label
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione fecha..."
                  />
                  <label>Desde:</label>
                </div>
              </div>
              <div class="form-field" v-show="form.tipoFecha == 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="desde"
                    v-model="form.fechaHasta"
                    locale="es"
                    only-date
                    no-label
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione fecha..."
                  />
                  <label>Hasta:</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div 
              class="form-field select2 select2-field--stretch"
              :class="{'select2--disabled': !administraTodasBodegas}"
            >
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @input="inputBodega"
                  label="descripcion"
                  placeholder="Seleccione..."
                  :options="optionsBodegas"
                  id="bodegas"
                  v-model="selectedBodega"
                ></v-select>
                <label for="bodegas">Sucursal:</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="registros.length > 0">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div v-show="nombreBodega != null && nombreBodega != ''" class="form-field">
              <h6>{{ `SUCURSAL: ${nombreBodega}` }}</h6>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="table-responsive">
              <table class="table--bordered">
                <thead>
                  <tr>
                    <th style="font-size: 10px; background-color:#F3F2F2;">
                      Producto
                    </th>
                    <th
                      style="font-size: 10px; background-color:#F3F2F2;"
                      v-for="(diaSemana, index) in diasSemana"
                      :key="index.toString() + moment(new Date()).format('YYYYMMDDHHmmss') + 'dia'"
                    >
                      <span>{{ diaSemana.nombre_dia }}</span>
                    </th>
                    <th style="font-size: 10px; background-color:#F3F2F2;">
                      Ventas
                    </th>
                    <th style="font-size: 10px; background-color:#F3F2F2;">
                      Precio
                    </th>
                    <th style="font-size: 10px; background-color:#F3F2F2;">
                      Monto
                    </th>
                  </tr>
                </thead>  
                <tbody>
                  <tr
                    v-for="(registro, index2) in registros"
                    :key="index2.toString() + moment(new Date()).format('YYYYMMDDHHmmss') + 'reg'"
                  >
                    <td style="font-size: 10px;">{{ registro.item_descripcion }}</td>
                    <td
                      style="font-size: 10px;"
                      v-for="(detalle, index3) in registro.detalles"
                      :key="index3.toString() + moment(new Date()).format('YYYYMMDDHHmmss') + 'detalle'"
                    >
                      <span>{{ detalle.cantidad }}</span>
                    </td>
                    <td style="font-size: 10px;">{{ registro.total_cantidad }}</td>
                    <td style="font-size: 10px;">
                      {{ 
                        moneyFormat(parseFloat(registro.total_valor) / parseFloat(registro.total_cantidad))
                      }}
                    </td>
                    <td style="font-size: 10px;">{{ moneyFormat(registro.total_valor) }}</td>
                  </tr> 
                  <tr>
                    <td style="font-size: 10px; background-color:#F3F2F2;"><b>TOTAL VENTAS:</b></td>
                    <td
                      style="font-size: 10px; background-color:#F3F2F2;"
                      v-for="(diaSemana, index4) in diasSemana"
                      :key="index4.toString() + moment(new Date()).format('YYYYMMDDHHmmss') + 'dia_total'"
                    >
                      <b>{{ diaSemana.cantidad }}</b>
                    </td>
                    <td style="font-size: 10px; background-color:#F3F2F2;"><b>{{ totalCantidad }}</b></td>
                    <td style="font-size: 10px; background-color:#F3F2F2;"><b>{{ moneyFormat(totalPrecio) }}</b></td>
                    <td style="font-size: 10px; background-color:#F3F2F2;"><b>{{ moneyFormat(totalValor) }}</b></td>
                  </tr>                 
                </tbody>              
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      name="historicos"
      height="auto"
      width="70%"
      scrollable
      adaptive
      resizable
      reset
    >
      <reportes-historicos-excel
        tipoReporte='vp'
      ></reportes-historicos-excel>
    </modal>
  </div>
</template>

<<script>
export default {
  props: {
    bodegas: {
      required: true
    },
    administraTodasBodegas: {
      type: Boolean,
      required: true
    },
    idBodegaUsuario: {
      required: true
    }
  },
  data: function() {
    return {
      moment: moment,
      moneyFormat: moneyFormat,
      registros: [],
      diasSemana: [],
      selectedBodega: null,
      nombreBodega: '',
      totalCantidad: 0,
      totalValor: 0,
      totalPrecio: 0,
      optionsBodegas: [],
      form: {
        tipoFecha: 'P',
        fechaDesde: '',
        fechaHasta: '',
        idBodega: null,   
      }
    }
  },
  methods: {
    consultar: function() {
      if(!this.validandoFiltros())
        return;
      let urlApi = `${url}/reporte-ventas-productos/consultar/C`;
      axios
        .post(urlApi, this.form)
        .then(response => {
          let data = response.data;
          this.nombreBodega = data.nombreBodega;
          this.totalCantidad = data.totalCantidad;
          this.totalValor = data.totalValor;
          this.totalPrecio = data.totalPrecio;
          this.diasSemana.splice(0, this.diasSemana.length);
          this.registros.splice(0, this.registros.length);
          this.diasSemana = [...data.diasSemana];
          this.registros = [...data.registros];
        }).catch(error => {
          swal('Error', 'No se pudo consultar el reporte', 'error');
        });
    },
    exportarDocumento: function(tipo){
      if(!this.validandoFiltros())
        return;
      let urlApi = `${url}/reporte-ventas-productos/consultar/${tipo}${this.serialize(this.form)}`;
      window.open(urlApi, '_blank');
    },
    validandoFiltros: function() {
      //Validando las fechas
      if(this.form.tipoFecha == 'P'){
        if(this.form.fechaDesde == null || this.form.fechaHasta == null){
          swal('Aviso', 'Las fechas son requeridas', 'warning');
          return false;
        }
        let desde = new Date(this.form.fechaDesde + ' 00:00:00');
        let hasta = new Date(this.form.fechaHasta + ' 00:00:00');
        if(desde == "Invalid Date" || hasta == "Invalid Date"){
          swal('Aviso', 'Debe ingresar correctamente las fechas', 'warning');
          return false;
        }
      }
      return true;
    },
    inputBodega: function(){
      this.form.idBodega = null;
      if(this.selectedBodega != null)
        this.form.idBodega = this.selectedBodega.id;
    },
    mostrarHistoricos: function () {
      this.$modal.show('historicos');
    },
    serialize : function ( obj ) {
      return (
        "?" +
        Object.keys(obj)
        .reduce(function(a, k) {
          let val = obj[k];
          let esArray = false;
          if (val instanceof Date) {
          val = val.toLocaleDateString("en");
          } else if (val instanceof Array) {
          esArray = true;
          let acumulador = "";
          for (let i = 0; i < val.length; i++) {
              acumulador += k + "%5B%5D=" + val[i];
              if (i != val.length - 1) {
              acumulador += "&";
              }
          }
          val = acumulador;
          a.push(val);
          }
          if (!esArray) a.push(k + "=" + encodeURIComponent(val));
          return a;
        }, [])
        .join("&")
      );
    },
  },
  mounted: function() {
    //Seteando fechas por defecto
    let desde = new Date();
    desde.setDate(desde.getDate() - 6);
    let hasta = new Date();
    this.form.fechaDesde = moment(desde).format("YYYY-MM-DD");
    this.form.fechaHasta = moment(hasta).format("YYYY-MM-DD");
    //Seteando bodegas
    if(this.administraTodasBodegas)
      this.optionsBodegas = [...this.bodegas];
    else{
      for(let i=0; i < this.bodegas.length; i++){
        if(this.idBodegaUsuario == this.bodegas[i].id){
          this.optionsBodegas.push(this.bodegas[i]);
          this.selectedBodega = this.bodegas[i];
          this.form.idBodega = this.bodegas[i].id;
          break;
        }
      }
    } 
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ReporteVentasProductos.vue